import React from 'react';
import PortalModal from 'Components/PortalModal/PortalModalContainer';
import AdditionalColumns from 'Components/PortalTable/AdditionalColumnsPopup/AdditionalColumnsPopupContainer';
import TransactionsPopup from 'Route/Home/components/TransactionsPopup/TransactionsPopupContainer';
import DeleteElectronicPurse from 'Route/ElectronicPurse/components/DeleteEPursePopup/DeleteEPursePopupContainer';
import DeleteUserPopup from 'Route/Users/components/DeleteUserPopup/DeleteUserPopupContainer';
import DeleteGroupPopup from 'Route/Groups/components/DeleteGroupPopup/DeleteGroupPopupContainer';
import PromotionStatusPopup from 'Route/Promotions/components/PromotionStatusPopup/PromotionStatusPopupContainer';
import ChangeLanguage from 'Route/Account/components/ChangeLanguage/ChangeLanguageContainer';
import ReverseTransactionAmount from 'Route/Transactions/components/ReverseTransactionAmountModal/ReverseTransactionAmountModalContainer';
import DeleteMerchantPopup from 'Route/Merchant/components/DeleteMerchantPopup/DeleteMerchantPopupContainer';
import DeleteStorePopup from 'Route/Store/components/DeleteStorePopup/DeleteStorePopupContainer';
import DeleteRegisterPopup from 'Route/Register/components/DeleteRegisterPopup/DeleteRegisterPopupContainer';
import DeleteCustomerCarePopup from 'Route/CustomerCare/components/DeleteCustomerCarePopup/DeleteCustomerCarePopupContainer';
import DisableCustomerCarePopup from 'Route/CustomerCare/components/DisableCustomerCarePopup/DisableCustomerCarePopupContainer';
import EnableCustomerCarePopup from 'Route/CustomerCare/components/EnableCustomerCarePopup/EnableCustomerCarePopupContainer';
import UnlockCustomerCarePopup from 'Route/CustomerCare/components/UnlockCustomerCarePopup/UnlockCustomerCarePopupContainer';

export const flowPopupTypes = {
	GENERIC_POPUP: 'GENERIC_POPUP',
	ADDITIONAL_COLUMNS: 'ADDITIONAL_COLUMNS',
	TRANSACTIONS_POPUP: 'TRANSACTIONS_POPUP',
	PROMOTION_STATUS_POPUP: 'PROMOTION_STATUS_POPUP',
	DELETE_ELECTRONIC_PURSE_POPUP: 'DELETE_ELECTRONIC_PURSE_POPUP',
	DELETE_USER_POPUP: 'DELETE_USER_POPUP',
	DELETE_GROUP_POPUP: 'DELETE_GROUP_POPUP',
	CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
	CHANGE_REVERSE_TX_AMOUNT: 'CHANGE_REVERSE_TX_AMOUNT',
	DELETE_MERCHANT_POPUP: 'DELETE_MERCHANT_POPUP',
	DELETE_STORE_POPUP: 'DELETE_STORE_POPUP',
	DELETE_REGISTER_POPUP: 'DELETE_REGISTER_POPUP',
	DELETE_CUSTOMER_CARE_POPUP: 'DELETE_CUSTOMER_CARE_POPUP',
	DISABLE_CUSTOMER_CARE_POPUP: 'DISABLE_CUSTOMER_CARE_POPUP',
	ENABLE_CUSTOMER_CARE_POPUP: 'ENABLE_CUSTOMER_CARE_POPUP',
	UNLOCK_CUSTOMER_CARE_POPUP: 'UNLOCK_CUSTOMER_CARE_POPUP',
};

export const flowPopupMap = {
	[flowPopupTypes.GENERIC_POPUP]: <PortalModal />,
	[flowPopupTypes.ADDITIONAL_COLUMNS]: <AdditionalColumns />,
	[flowPopupTypes.TRANSACTIONS_POPUP]: <TransactionsPopup />,
	[flowPopupTypes.PROMOTION_STATUS_POPUP]: <PromotionStatusPopup />,
	[flowPopupTypes.DELETE_ELECTRONIC_PURSE_POPUP]: <DeleteElectronicPurse />,
	[flowPopupTypes.DELETE_USER_POPUP]: <DeleteUserPopup />,
	[flowPopupTypes.DELETE_GROUP_POPUP]: <DeleteGroupPopup />,
	[flowPopupTypes.CHANGE_LANGUAGE]: <ChangeLanguage />,
	[flowPopupTypes.CHANGE_REVERSE_TX_AMOUNT]: <ReverseTransactionAmount />,
	[flowPopupTypes.DELETE_MERCHANT_POPUP]: <DeleteMerchantPopup />,
	[flowPopupTypes.DELETE_STORE_POPUP]: <DeleteStorePopup />,
	[flowPopupTypes.DELETE_REGISTER_POPUP]: <DeleteRegisterPopup />,
	[flowPopupTypes.DELETE_CUSTOMER_CARE_POPUP]: <DeleteCustomerCarePopup />,
	[flowPopupTypes.DISABLE_CUSTOMER_CARE_POPUP]: <DisableCustomerCarePopup />,
	[flowPopupTypes.ENABLE_CUSTOMER_CARE_POPUP]: <EnableCustomerCarePopup />,
	[flowPopupTypes.UNLOCK_CUSTOMER_CARE_POPUP]: <UnlockCustomerCarePopup />,
};

export const getPopupByID = (id) => flowPopupMap[id];

export default flowPopupMap;
